import {
    Box,
    BoxedRow,
    EmptyState,
    Spinner,
    Stack,
    Tabs,
    Text2,
    Text3,
    Inline,
    skinVars,
    IconBoxRegular,
    TextLink,
} from '@telefonica/mistica';
import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import OnlyMobile from '../OnlyMobile/index';
import Convergent from '../Convergent';
import OnlyFiber from '../OnlyFiber';
import { getAllProducts } from '../../services/ProductService';
import { getAllConsumption } from '../../services/ConsumptionService';
import {
    addConsumptions,
    addDataSharing,
    getAllProductsId,
    getProducts,
} from '../../utils/dataTransformation/productConsumption';
import { useDispatch } from 'react-redux';
import { ETypeUser, RestrictionType } from '../../utils/store/model/store.model';
import { useTranslation } from 'react-i18next';
import { AxiosError, AxiosResponse } from 'axios';
import navigateParams from '../../utils/navigation/navigateParams';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../utils/globals/GlobalContext';
import InfiniteScroll from 'react-infinite-scroll-component';
import { isBrowser } from 'react-device-detect';
import { IUserProducts } from '../../models/Products.interfaces';
import { getOrders } from '../../services/OrderService';
import { Order } from '../../models/Orders';
import dayjs from 'dayjs';
import { OrderStatusTag } from '../../pages/profile/orders/statusTags';
import { getAllRestrictions } from '../../services/ConfigureLineService';
import { useConfigureLineContext } from '../../utils/store/context/configure-line-context/ConfigureLineContext';
import { checkBlockedLineRestriction, getBlockLineRestrictionId } from '../../utils/dataTransformation/restrictions';

export const TabsHome: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { setBlockedLines, setBlockedLineRestrictionId } = useConfigureLineContext();
    const [moreElements, setMoreElements] = useState(true);
    const [page, setPage] = useState(1);
    const navigate = useNavigate();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [orders, setOrders] = useState<Order[]>([]);
    const [textTabs, setTextTabs] = useState<string[]>([]);
    const [typeTabs, setTypeTabs] = useState([0]);
    const [dataTabs, setDataTabs] = useState([{}]);
    const [loading, setLoading] = useState(true);
    const [sharedData, setSharedData] = useState([{}]);
    const [rentings, setRentings] = useState<any>({});
    const [triggerRestrictions, setTriggerRestrictions] = useState(false);
    const { setContext, context } = useGlobalContext();
    const typeUser = new URLSearchParams(window.location.search).get('clientType');
    let infoUser = {
        bundles: [],
        fibers: [],
        mobiles: [],
        rentings: [],
        typeUser: typeUser,
    };
    const [isPreClient, setIsPreClient] = useState(false);
    const [emptyProducts, setEmptyProducts] = useState<boolean>(false);

    const firstRender = useRef(true);

    useEffect(() => {
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }

        const mobileIds: string[] = [];
        const additionalMobiles = context?.bundles[0]?.additionalMobiles;
        const mobileLines = context?.mobiles;

        if (context?.bundles[0]?.mainMobile?.productId) mobileIds.push(context?.bundles[0]?.mainMobile?.productId);
        if (additionalMobiles && additionalMobiles.length > 0)
            additionalMobiles.forEach((line: any) => mobileIds.push(line.productId));
        if (mobileLines && mobileLines.length > 0) mobileLines.forEach((line: any) => mobileIds.push(line.productId));

        if (mobileIds && mobileIds.length) checkAllRestrictions(mobileIds);
    }, [triggerRestrictions]);

    const checkAllRestrictions = async (mobileIds: string[]) => {
        try {
            const responses = await Promise.all(mobileIds.map((id) => getAllRestrictions(id)));

            const restrictionId =
                responses.map((res) => getBlockLineRestrictionId(res.data as RestrictionType[]))[0] ?? '';
            const blockedIds = responses
                .map((res, index) =>
                    checkBlockedLineRestriction(res.data as RestrictionType[]) ? mobileIds[index] : null,
                )
                .filter((id) => id !== null);

            setBlockedLines(blockedIds as string[]);
            setBlockedLineRestrictionId(restrictionId);
        } catch (error) {
            console.log(error);
        }
    };

    const handleGetOrders = () => {
        getOrders({ page, size: 10 })
            .then((response: AxiosResponse) => {
                setPage(page + 1);
                setLoading(false);
                setMoreElements(response.data.moreElements);
                setOrders(orders.concat(response.data.orders) || []);
            })
            .catch(() => {
                setLoading(false);
                setEmptyProducts(true);
            });
    };

    const updateProducts = async (response: AxiosResponse, role: string) => {
        const { bundles, fibers, mobiles, rentings } = response.data;
        let _isPreClient = typeUser === ETypeUser.PRECLIENT;
        infoUser = { bundles, fibers, mobiles, rentings, typeUser: role as ETypeUser };
        setContext({ ...infoUser });
        setTriggerRestrictions(true);
        setIsPreClient(_isPreClient);
        if (_isPreClient) {
            handleGetOrders();
        } else {
            addTextTabs(response.data);
        }
    };

    useEffect(() => {
        let isLoaded = true;
        const fetchData = async () => {
            await getAllProducts()
                .then(async (res: AxiosResponse) => {
                    const { data } = res;
                    if (typeUser) {
                        const empty: boolean = Object.values(data).every(
                            (product: unknown) => (product as []).length === 0,
                        );
                        setEmptyProducts(empty);
                        updateProducts(res, typeUser);
                    } else {
                        const role = window.localStorage.getItem('scope');
                        updateProducts(res, role as string);
                    }
                })
                .catch((err: AxiosError) => {
                    if (err.response?.status === 499) {
                        setEmptyProducts(true);
                    }
                    setLoading(false);
                });
        };
        if (isLoaded) {
            fetchData();
        }
        return () => {
            isLoaded = false;
        };
    }, [dispatch]);

    const addTextTabs = (dataProducts: IUserProducts): void => {
        //Type tabs 1-> convergent, 2-> fiber, 3->mobile
        const { _dataTabs, _indexTabs, _nameTabs } = getProducts(dataProducts);
        const allProductsId: string[] = getAllProductsId(dataProducts);
        if (allProductsId.length > 0) {
            getAllConsumption(allProductsId)
                .then((res: any) => {
                    //adding consumption info to products
                    let consumptions = addConsumptions(res.data, _dataTabs.flat());
                    let sharedData = addDataSharing(res.data, _dataTabs.flat());
                    setTextTabs(_nameTabs);
                    setTypeTabs(_indexTabs.flat());
                    setDataTabs(consumptions);
                    setSharedData(sharedData);
                    setRentings(dataProducts?.rentings);
                    setContext({ ...infoUser, consumptions, sharedData });
                    setLoading(false);
                })
                .catch((err: AxiosError) => {
                    setLoading(false);
                });
        } else {
            setLoading(false);
            setEmptyProducts(true);
        }
    };

    const setInfoStore = () => {
        const consumptions = dataTabs.map((item: any) => ({ ...item, sharedData }));
        window.localStorage.setItem('storages', JSON.stringify(consumptions));
    };

    const lineConvergent = () => {
        setInfoStore();
        return textTabs.map((_value, index) => {
            const dataTab1 = dataTabs[index];
            if (loading) {
                return (
                    <div key={index} className='tabs-home__loading'>
                        <div className='tabs-home__loading__spinner'>
                            <Spinner size={'32px'} color={skinVars.colors.navigationBarBackground}></Spinner>
                        </div>
                    </div>
                );
            } else {
                return (
                    selectedIndex === index &&
                    typeTabs[index] === 1 && (
                        <Convergent key={index} dataTab={dataTab1} sharedData={sharedData} rentings={rentings} />
                    )
                );
            }
        });
    };

    const lineOnlyFiber = () => {
        setInfoStore();
        return textTabs.map((_value, index) => {
            const dataTab2 = dataTabs[index];
            if (loading) {
                return (
                    <div key={index} className='tabs-home__loading'>
                        <div className='tabs-home__loading__spinner'>
                            <Spinner size={'32px'} color={skinVars.colors.navigationBarBackground}></Spinner>
                        </div>
                    </div>
                );
            } else {
                return selectedIndex === index && typeTabs[index] === 2 && <OnlyFiber key={index} dataTab={dataTab2} />;
            }
        });
    };

    const lineOnlyMobile = () => {
        setInfoStore();
        return textTabs.map((_value, index) => {
            const dataTab3 = dataTabs[index];
            if (loading) {
                return (
                    <div key={index} className='tabs-home__loading'>
                        <div className='tabs-home__loading__spinner'>
                            <Spinner size={'32px'} color={skinVars.colors.navigationBarBackground}></Spinner>
                        </div>
                    </div>
                );
            } else {
                return (
                    selectedIndex === index && typeTabs[index] === 3 && <OnlyMobile key={index} dataTab={dataTab3} />
                );
            }
        });
    };

    const clientNormal = () => {
        if (emptyProducts) {
            return (
                <Stack space={16}>
                    {!loading && (
                        <div className='tabs-home__preclient-emptyState'>
                            <EmptyState
                                icon={<IconBoxRegular color={skinVars.colors.brand} size={64} />}
                                title={t('contractedProducts')}
                                description={t('stateListProducts')}
                            ></EmptyState>
                        </div>
                    )}
                </Stack>
            );
        } else {
            return (
                <>
                    {lineConvergent()}
                    {lineOnlyFiber()}
                    {lineOnlyMobile()}
                </>
            );
        }
    };

    const sendToNative = (url: string, type: string, title: string, id?: string) => {
        const storage = { id };
        const queryParams = { id };
        localStorage.setItem('storage', JSON.stringify(storage));
        if (url === '/devices') {
            if (navigateParams(type, url, queryParams, storage, title, id)) {
                navigate(`${url}?id=${id}`, { state: rentings });
            }
        } else if (url === '/order-detail') {
            if (navigateParams(type, `${url}`, queryParams, storage, title, id)) {
                navigate(`${url}?id=${id}`);
            }
        } else if (url === '/explore') {
            navigateParams(type, url, queryParams, storage, title, id);
        } else if (url === `${process.env.REACT_APP_WEBVIEW_O2CLOUD}`) {
            navigateParams(type, url, queryParams, storage, title, id, false);
        } else if (url === `${process.env.REACT_APP_WEBVIEW_DEVICES}` || `${process.env.REACT_APP_WEBVIEW_POSTSALES}`) {
            navigateParams(type, url, queryParams, storage, title, id, false);
        } else if (url === `${process.env.REACT_APP_WEBVIEW_O2TELEVISION}`) {
            navigateParams(type, url, queryParams, storage, t('cardTelevisionTagText'), id, false);
        }
    };

    const clientPreactive = () => {
        return (
            <Stack space={16}>
                {!orders || orders[0] === undefined ? (
                    <div className='tabs-home__preclient-emptyState'>
                        <EmptyState
                            icon={<IconBoxRegular color={skinVars.colors.brand} size={64} />}
                            title={t('contractedProducts')}
                            description={t('stateListProducts')}
                        ></EmptyState>
                    </div>
                ) : (
                    <div className='tabs-home__preclient-orders'>
                        {orders?.length > 0 && (
                            <InfiniteScroll
                                dataLength={orders.length}
                                next={handleGetOrders}
                                hasMore={moreElements}
                                loader={
                                    <div className='orders-page'>
                                        <div
                                            className='orders-page__loading'
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                color: skinVars.colors.textSecondary,
                                                padding: '16px',
                                            }}
                                        >
                                            <Inline space={8} alignItems='center'>
                                                <Spinner
                                                    size={24}
                                                    color={skinVars.colors.navigationBarBackground}
                                                ></Spinner>
                                                {t('loading')}
                                            </Inline>
                                        </div>
                                    </div>
                                }
                            >
                                <Text3 regular>{t('descriptionContractedProducts')}</Text3>
                                <Box paddingY={8}>
                                    {orders!.map((item, index) => {
                                        return (
                                            <Box key={index} paddingY={8}>
                                                <BoxedRow
                                                    right={<OrderStatusTag status={item.status}></OrderStatusTag>}
                                                    title={item.description}
                                                    extra={
                                                        <div>
                                                            <div className='orders-page__extra'>
                                                                <div className='orders-page__extra-startDate'>
                                                                    <Text2 regular color={skinVars.colors.textPrimary}>
                                                                        {t('ordersState')}
                                                                    </Text2>
                                                                    <Text2
                                                                        regular
                                                                        color={skinVars.colors.textSecondary}
                                                                    >
                                                                        {dayjs(item.startDate as any).format(
                                                                            'DD/MM/YYYY',
                                                                        )}
                                                                    </Text2>
                                                                </div>
                                                                {item.finishDate && (
                                                                    <div className='orders-page__extra-finishDate'>
                                                                        <Text2
                                                                            regular
                                                                            color={skinVars.colors.textPrimary}
                                                                        >
                                                                            {t('ordersTagDone')}
                                                                        </Text2>
                                                                        <Text2
                                                                            regular
                                                                            color={skinVars.colors.textSecondary}
                                                                        >
                                                                            {dayjs(item.finishDate as any).format(
                                                                                'DD/MM/YYYY',
                                                                            )}
                                                                        </Text2>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className='orders-page__extra-link'>
                                                                <TextLink
                                                                    onPress={() => {
                                                                        sendToNative(
                                                                            '/order-detail',
                                                                            'modeFlow-backgroundBlue',
                                                                            t('orderDetail'),
                                                                            item.id,
                                                                        );
                                                                    }}
                                                                >
                                                                    {t('moreInformationLink')}
                                                                </TextLink>
                                                            </div>
                                                        </div>
                                                    }
                                                ></BoxedRow>
                                            </Box>
                                        );
                                    })}
                                </Box>
                            </InfiniteScroll>
                        )}
                    </div>
                )}
            </Stack>
        );
    };

    return (
        <div className={isBrowser ? 'tabs-home-browser' : 'tabs-home'}>
            {!isPreClient && !loading && !emptyProducts && (
                <Tabs
                    selectedIndex={selectedIndex}
                    onChange={setSelectedIndex}
                    tabs={textTabs.map((text) => ({
                        text,
                    }))}
                />
            )}
            {!isPreClient && !loading && <>{clientNormal()}</>}
            {isPreClient && !loading && clientPreactive()}
        </div>
    );
};
export default TabsHome;
